import React from "react";
import Pagination from "../../pagination";
const QueryPagination = (props) => {
    return React.createElement(Pagination, { ...props });
};
QueryPagination._ges_name = "QueryPagination";
export default QueryPagination;
